import { DataSource } from '@angular/cdk/collections';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { FlashyDataService } from '@abstract/FlashyDataService';
import { FlashyFileService } from '@flashy/store/file';
import {
  FlashyProductsService,
  IFlashyUiImageFile,
} from '@flashy/store/products';
import { FlashyUiModalHelperUri } from 'uix/file-picker';

@Injectable({
  providedIn: 'root',
})
export class FlashyUiModalHelper extends FlashyUiModalHelperUri {
  readonly fileService = inject(FlashyFileService);
  readonly productsService = inject(FlashyProductsService);
  searchQuery$ = new Subject<{
    q: '';
    catalog: null;
    category: null;
    variant: null;
    stock: null;
  }>();

  getImageFiles(): Observable<DataSource<IFlashyUiImageFile>> {
    this.fileService.setEntities([]);
    this.fileService.setCount(0);
    return this.searchQuery$.pipe(
      map(
        (query) =>
          new FlashyDataService<IFlashyUiImageFile>((page) =>
            this.fileService
              .getAll({ page, query: query.q })
              .pipe(map(({ results }) => results))
          )
      )
    );
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  getProducts(): Observable<DataSource<any>> {
    this.productsService.setEntities([]);
    this.productsService.setCount(0);
    return this.searchQuery$.pipe(
      map(
        (query) =>
          new FlashyDataService<unknown>((page) => {
            const params: Record<string, string | number> = {
              page,
              variant: query.variant,
              query: query.q,
              stock: query.stock,
            };
            if (query.catalog) {
              params.catalog_id = query.catalog;
            }
            if (query.category) {
              params.category = query.category;
            }
            return this.productsService
              .getAll(params)
              .pipe(map(({ results }) => results));
          })
      )
    );
  }
}
